import React, { useContext } from 'react'
import { Card, Typography } from '@mui/material'

import { updateAnswer } from '../Utilities/SetNewAnswer'
import { highlightSelect, diminishSelect } from "../Utilities/SetHighlightStyle"

import { AnswersType } from '../Models/AnswersType';
import { selectConfigFull, selectConfigLight } from '../Data/answers';
import { AnswerNumber } from "../Models/AnswerNumberType"

import { flexSpaceC } from '../Styles/EvaluationToolTheme';
import { evaluationStageType } from '../Models/EvaluationStageType';

import { PolyglotContext } from '../../../polyglot/polyGlotContext';

interface AnswerSelectCardProps {
    answerNumber: AnswerNumber;
    collectedAnswers: AnswersType;
    setCollectedAnswers: React.Dispatch<React.SetStateAction<AnswersType>>;
    index: number;
    evaluationStage: evaluationStageType;
}

const AnswerSelectCard = ({
    answerNumber,
    collectedAnswers,
    setCollectedAnswers,
    index,
    evaluationStage,
}: AnswerSelectCardProps) => {
    const { polyglot } = useContext(PolyglotContext)

    let selectedAnswer;
    if (evaluationStage === "beforeFull" || evaluationStage === "afterFull") {
        selectedAnswer = selectConfigFull[answerNumber] || [];
    } else {
        selectedAnswer = selectConfigLight[answerNumber] || [];
    }

    const { imgUrl: imgUrl, imgAlt: imgAlt, typographyTextContent: typographyTextContent, answerData: answerData } = selectedAnswer[index] || {}

    return (
        <Card
            sx={{
                ...flexSpaceC,
                boxShadow: "none",
                borderRadius: "none",
                height: "100%",
                width: "100%",
            }}
            onClick={() => {
                updateAnswer({ [answerNumber]: answerData }, setCollectedAnswers)
            }}
        >
            <img src={imgUrl} alt={polyglot.t(imgAlt)} className={`${highlightSelect(index + 1, collectedAnswers, answerNumber)}${diminishSelect(index + 1, collectedAnswers, answerNumber)}`}
                style={{
                    borderRadius: "20px", padding: "24px 16px", height: "75%", objectFit: "contain", cursor: "pointer"
                }}
            />

            <Typography
                className={`${diminishSelect(index + 1, collectedAnswers, answerNumber)}`}
                variant="h2"
                color="initial"
                sx={{
                    textAlign: "center",
                }}
            >
                {polyglot.t(typographyTextContent)}
            </Typography>
        </Card>
    )
}

export default AnswerSelectCard
